import * as React from "react";

import {
  type ThreeDPanelState,
  type ThreeDEntity,
} from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import styles from "../SettingsSection.module.css";
import { Spotlight } from "../Spotlight";

import { EntityConfig } from "./EntityConfig/EntityConfig";
import { CameraSettings } from "./SceneConfig/CameraSettings";
import { GridSettings } from "./SceneConfig/GridSettings";

export interface ThreeDPanelSettingsSidebarProps
  extends PanelSettingsSidebarProps {
  field?: `Entity ${string}` | "Add entity";
}

interface ThreeDPanelSettingsProps extends ThreeDPanelSettingsSidebarProps {
  state: ThreeDPanelState;
}

export function ThreeDPanelSettings({
  field,
  state,
  spotlightKey,
}: ThreeDPanelSettingsProps) {
  const entities = React.useMemo(
    () => Object.values(state.data.entities),
    [state.data.entities],
  );
  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Camera">
        <CameraSettings panelId={state.id} />
      </SettingsSection>
      <SettingsSection title="Scenery">
        <GridSettings panelId={state.id} />
      </SettingsSection>
      {entities.map((entity: ThreeDEntity) => (
        <SettingsSection key={entity.id} title={`Entity ${entity.id}`}>
          <div className={styles.settings}>
            <EntityConfig panelId={state.id} entity={entity} />
          </div>
          <Spotlight
            className={styles.settingContainer}
            spotlightKey={
              field === `Entity ${entity.id}` ? spotlightKey : undefined
            }
          ></Spotlight>
        </SettingsSection>
      ))}
      <Spotlight
        className={styles.settingContainer}
        spotlightKey={field === "Add entity" ? spotlightKey : undefined}
      >
        {/*TODO: add support for adding a new entity as part of the panel setup experience. */}
      </Spotlight>
    </BasePanelSettings>
  );
}
